// @flow
import * as React from 'react';
import {useState} from 'react';

import Group from 'sail/Group';
import Dialog, {DialogHeader, DialogContent, DialogFooter} from 'sail/Dialog';
import Button from 'sail/Button';
import {useDiagramGenerator} from 'docs/data/diagram';
import {generateId} from '../util/generateId';
import {SetNodeId} from './SetNodeId';
import {SetNodeText} from './SetNodeText';

export const AddSequenceNode = () => {
  const {addNode} = useDiagramGenerator();
  const [text, setText] = useState('');
  // Autogenerate an ID for this node
  const [id, setId] = useState('');

  return (
    <Dialog width="medium">
      <DialogHeader title="Add vertical line" />
      <DialogContent padding={20}>
        <Group spacing={16}>
          <SetNodeText
            text={text}
            onBlur={(evt) => {
              if (!id) {
                setId(generateId(evt.target.value));
              }
            }}
            onChange={setText}
          />
          <SetNodeId id={id} setId={setId} />
        </Group>
      </DialogContent>
      <DialogFooter
        end={
          <Button
            label="Add"
            onClick={() => {
              addNode({id}, text);
            }}
          />
        }
      />
    </Dialog>
  );
};
